/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */

import 'foundation-sites';
import AOS from 'aos';
import MmenuLight from 'mmenu-light';

document.addEventListener( 'DOMContentLoaded', () => {
	// Globally call foundation
	$( document ).foundation();

	// Mobile menu
	const menuHolder = document.querySelector( '#nav' );

	if ( menuHolder ) {
		const menu = new MmenuLight(
			menuHolder,
			'(max-width: 1023px)',
		);

		menu.navigation( {
			selected: 'is-active',
			title: 'Menu',
			theme: 'light',
		} );

		const drawer = menu.offcanvas( {
			position: 'left',
		} );

		document.querySelector( 'a[href="#nav"]' ).addEventListener( 'click', ( event ) => {
			event.preventDefault();
			drawer.open();
		} );
	}

	// AOS Animation
	AOS.init( {
		duration: 800,
		delay: 100,
		once: true,
	} );

	// Sticky header
	$( window ).scroll( function() {
		if ( $( window ).scrollTop() >= 100 ) {
			$( '.header' ).addClass( 'header--fixed' );
		} else {
			$( '.header' ).removeClass( 'header--fixed' );
		}
	} );
} );
